// extracted by mini-css-extract-plugin
module.exports = {"selection":"selectedMeds_selection__25S8B","item":"selectedMeds_item__3CV85","name":"selectedMeds_name__3z18x","cross":"selectedMeds_cross__2cuB8"};